import type { ReactNode } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';

import { cn } from '../../../lib';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../forms';

export type TabItem = {
  label: ReactNode;
  href: string;
};

export const TabsMenu = ({ tabs, className }: { tabs: TabItem[]; className?: string }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const current = tabs.find(tab => tab.href === location.pathname);
  return (
    <div className={className}>
      <div className="sm:hidden">
        <Select onValueChange={value => navigate(value)} value={current?.href}>
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {tabs.map(tab => (
              <SelectItem key={tab.href + tab.label} value={tab.href}>
                {tab.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="hidden sm:block">
        <nav className="relative flex flex-wrap border-b-2 border-gray-200" aria-label="Tabs">
          {tabs.map(tab => (
            <NavLink
              end
              key={tab.href}
              to={tab.href}
              className={({ isActive }) =>
                cn(
                  '-mb-0.5 border-b-2 border-gray-200 py-3 px-4 text-center text-sm font-medium whitespace-nowrap',
                  isActive
                    ? 'border-primary text-primary'
                    : 'text-gray-500 hover:border-gray-300 hover:text-gray-700',
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
};
